import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, set } from 'lodash';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import LeisureTravelFormContainer from './LeisureTravelFormContainer';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { actions as reduxProductActions } from '../redux/productActions';
import { getPolicy } from '../../policy/redux/policyActions';
import LeavingContainer from './LeavingContainer';
import PersonalAccidentFormContainer from './PersonalAccidentFormContainer';
import SourceSelect from '../components/SourceSelect/SourceSelect';
import { isBroker } from '../../auth/redux/authActions';
import SmartLuggageFormContainer from './SmartLuggageFormContainer';
import { getMarketingFlags } from '../helpers';

export class ProductMTAContainer extends Component {
  state = {
    nextLocation: null,
    currentOrganisation: '',
  };

  componentDidMount() {
    const {
      dispatch,
      auth,
      productActions,
      params: { policyId, id },
    } = this.props;
    const currentOrganisation = getIncludedResource(
      auth.user.data,
      auth.user.included,
      'current_organisation',
    );
    this.setState({
      currentOrganisation: currentOrganisation.data.attributes.name,
    });
    if (policyId) {
      Promise.resolve(
        dispatch(
          getPolicy(policyId, false, [
            'customer',
            'broker',
            'schemes',
            'policies',
            'applications',
            'channel',
            'premiums.scheme',
            'source',
            'product',
          ]),
        ),
      ).then((resp) => {
        const channel = getIncludedResource(resp.data, resp.included, 'channel');
        const broker = getIncludedResource(resp.data, resp.included, 'broker');

        const marketingFlags = getMarketingFlags(broker?.data, channel?.data);
        this.setState({
          marketingFlags,
        });
      });
    }

    productActions.getProduct(id);
    this.props.router.setRouteLeaveHook(this.props.route, ::this.routerWillLeave);
  }

  cancelLeave = () => {
    this.setState({
      nextLocation: null,
    });
  };

  attemptLeave = (location) => {
    this.setState({
      nextLocation: location,
    });
  };

  routerWillLeave(nextLocation) {
    const { auth, router } = this.props;
    const currentOrganisation = getIncludedResource(
      auth.user.data,
      auth.user.included,
      'current_organisation',
    );

    if (nextLocation.state && nextLocation.state.leaveConfirmed) {
      return true;
    }
    if (this.props.product.submitSucceeded || nextLocation.pathname === '/login') {
      return true;
    }

    // Do not display the confirm dialog if the user changed the Organisation by Settings -> Organisation Settings
    if (this.state.currentOrganisation === currentOrganisation.data.attributes.name) {
      this.attemptLeave(nextLocation);
    } else {
      router.push(nextLocation);
    }
    return false;
  }

  onModalClose() {
    this.setState(() => ({
      nextLocation: null,
    }));
  }

  getCurrentBrokerB2CChannel() {
    const { user } = this.props;
    if (isBroker()) {
      const currentBroker = getIncludedResource(
        user.data,
        user.included,
        'current_broker',
      );
      const channel = getIncludedResource(currentBroker.data, user.included, 'channel');
      return channel.data.attributes ? channel : null;
    }
    return null;
  }

  /**
   * Clean out the data when the component unmounts
   */
  componentWillUnmount() {
    const { productActions } = this.props;
    productActions.clearData();
  }

  render() {
    const {
      product,
      policy,
      params: { id, policyId },
      auth: { user },
    } = this.props;

    const { marketingFlags } = this.state;
    const productResource = product.resources[id];
    const application = policy.resources[policyId];
    const title = productResource ? productResource.data.attributes.name : '';
    if (!productResource || (policyId && !application)) {
      return (
        <InternalContainer hideBreadcrumbs title={title}>
          <Loader />
        </InternalContainer>
      );
    }
    const isExpired = application.data.attributes.status === 'expired';
    // unset the id on new mtas
    set(application, 'data.id', '');
    const journey = productResource.data.attributes.metadata.quote_journey;
    const productCode = productResource.data.attributes.product_code;
    const source = getIncludedResource(application.data, application.included, 'source');

    if (journey === 'personal_accident') {
      return (
        <InternalContainer hideBreadcrumbs title={title}>
          <SourceSelect
            isDisabled
            value={{
              value: source.data.id,
              label: source.data.attributes.name,
            }}
          />
          <PersonalAccidentFormContainer
            source={source.data}
            // brokerId={brokerId}
            // channelId={channelId}
            policyId={policyId}
            productId={id}
            isMta
            // isEditingQuote={edit}
            // isRenewal={renewal}
            application={application}
            currentProduct={productResource}
            isCloned={false}
            user={user}
          />
          <LeavingContainer
            next={this.state.nextLocation}
            handleClose={this.cancelLeave}
            mta
          />
        </InternalContainer>
      );
    }
    if (productCode === 'TRAV') {
      // sort out signposting for mtas
      const signpost = get(application, 'data.attributes.metadata.signposted');
      if (signpost) {
        set(application, 'data.attributes.metadata.signposted', false);
        set(application, 'data.attributes.metadata.signpost_acknowledged', false);
        set(application, 'data.attributes.metadata.storage.policy_signpost', signpost);
      }
      const premiums = getIncludedResource(
        application.data,
        application.included,
        'premiums',
      );

      const lastIssuedPremium = premiums.reduce((carry, premium) => {
        if (!carry) {
          return premium;
        }

        if (!premium.attributes.issued_at) {
          return null;
        }
        const premiumIssuedAt = moment(premium.attributes.issued_at);
        const existingPremiumIssuedAt = moment(carry.attributes.issued_at);
        if (premiumIssuedAt.isAfter(existingPremiumIssuedAt)) {
          return premium;
        }
        return carry;
      }, null);
      const lastIssuedPremiumMedical = get(
        lastIssuedPremium,
        'attributes.mta.new_premium.medical',
        lastIssuedPremium?.attributes?.medical,
      );
      if (lastIssuedPremiumMedical) {
        set(
          application,
          'data.attributes.metadata.storage.policy_medical',
          lastIssuedPremiumMedical,
        );
      }

      return (
        <InternalContainer hideBreadcrumbs title={title}>
          <SourceSelect
            isDisabled
            value={{
              value: source.data.id,
              label: source.data.attributes.name,
            }}
          />
          <LeisureTravelFormContainer
            mta
            source={source.data}
            policyId={policyId}
            productId={id}
            application={application}
            currentProduct={productResource}
            user={user}
            isExpired={isExpired}
            isMarketingEnabled={marketingFlags?.marketing_enabled}
            isInsuranceMarketingOptionsEnabled={
              marketingFlags?.insurance_marketing_options_enabled
            }
            isCarInsuranceMarketingEnabled={
              marketingFlags?.car_insurance_marketing_enabled
            }
            isHomeInsuranceMarketingEnabled={
              marketingFlags?.home_insurance_marketing_enabled
            }
          />
          <LeavingContainer
            next={this.state.nextLocation}
            handleClose={this.cancelLeave}
            mta
          />
        </InternalContainer>
      );
    }
    if (productCode === 'SL') {
      return (
        <InternalContainer hideBreadcrumbs={true} title={'Get a Quote'} bottomBar={true}>
          <SmartLuggageFormContainer
            application={application}
            currentProduct={productResource}
            policyId={policyId}
            productId={id}
            isMta={true}
            user={user}
          />
          <LeavingContainer
            next={this.state.nextLocation}
            handleClose={this.cancelLeave}
            mta={true}
          />
        </InternalContainer>
      );
    }
  }
}

export default connect(
  (state) => ({
    product: state.product,
    policy: state.policy,
    auth: state.auth,
    user: state.auth.user,
  }),
  (dispatch) => ({
    productActions: bindActionCreators(reduxProductActions, dispatch),
    dispatch,
  }),
)(ProductMTAContainer);
